/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import Matrix from './matrix/Matrix'
import useStyles from './Styles'
import { Box } from '@mui/material'
import PressCenter from './PressCenter'
import HeroHeader from 'src/components/shared/modules/heroHeader/HeroHeader'
import { contentType } from 'src/types/components/shared/atom'
// import { useGetPageByNameQuery } from 'src/store/ApiCall/pagesAPI'
import {
  pressCenterI,
  pressCenterAccordianI,
  RecentPressI,
} from 'src/types/store/index'
import HeadTag from 'src/components/layout/head'
import Skeleton from 'src/components/shared/modules/skeleton'
import { useGetRecentPressApiQuery } from 'src/store/ApiCall/getRecentPress'

interface Props {
  zenMode: boolean
  data?: any
}

function PressContent({ zenMode, data }: Props) {
  const { classes } = useStyles()
  // const { data } = useGetPageByNameQuery('press')
  const { data: recentPressData } = useGetRecentPressApiQuery()
  const [header, setHeader] = React.useState<contentType>()
  const [pressCenter, setPressCenter] = React.useState<pressCenterI>()
  const [recentPress, setRecentPress] = React.useState<RecentPressI[]>()
  const [placeholderText, setPlaceholderText] = React.useState<string>()
  const [poweredByAiText, setPoweredByAiText] = React.useState<string>()
  const [pressCenterAccordian, setPressCenterAccordian] =
    React.useState<pressCenterAccordianI[]>()
  const [pressSlideContent, setPressSlideContent] =
    React.useState<{ slideText: string }[]>()

  React.useEffect(() => {
    if (data && data.data.length > 0) {
      const content = data.data[0].attributes
      const { heroHeader, pressCenter, pressCenterAccordian, pressSlide } =
        content

      if (heroHeader) {
        const {
          primaryText,
          secondaryText,
          tertiaryText,
          poweredbyaiText,
          searchPlaceholder,
        } = heroHeader
        const headerText: contentType = {
          content: {
            secondary: {
              content: secondaryText,
              variant: 'h3',
              type: 'secondary',
            },
            primary: {
              content: primaryText,
              variant: 'h1',
              type: 'primary',
            },
            tertiary: {
              content: tertiaryText,
              variant: 'subtitle1',
              type: 'tertiary',
            },
          },
        }

        setHeader(headerText)

        if (searchPlaceholder) setPlaceholderText(searchPlaceholder)
        if (poweredbyaiText) setPoweredByAiText(poweredbyaiText)
      }

      if (pressCenter) setPressCenter(pressCenter)
      if (pressCenterAccordian) setPressCenterAccordian(pressCenterAccordian)
      if (pressSlide) setPressSlideContent(pressSlide)
    }

    if (recentPressData && recentPressData.data.length > 0) {
      setRecentPress(recentPressData.data)
    }
  }, [data, recentPressData])

  return (
    <>
      <HeadTag
        title={data?.data[0].attributes.metaTitle}
        description={data?.data[0].attributes.metaDescription}
      />
      <div>
        {header ? (
          <HeroHeader
            searchField={false}
            endAdornment={false}
            placeHolder={placeholderText}
            poweredText={poweredByAiText}
            heroContent={header}
          />
        ) : (
          <Skeleton />
        )}
        <Box
          className={`${classes.matrixBox} ${zenMode && classes.zenModeWithBg}`}
        >
          {recentPress && pressSlideContent && (
            <Matrix
              content={pressSlideContent}
              zenMode={zenMode}
              recentPress={recentPress}
            />
          )}
        </Box>
        {pressCenter && pressCenterAccordian && (
          <PressCenter
            pressCenter={pressCenter}
            pressCenterAccordian={pressCenterAccordian}
          />
        )}
      </div>
    </>
  )
}

export default PressContent
